import { render, staticRenderFns } from "./Quotation-Table.vue?vue&type=template&id=8b2c3468&scoped=true"
import script from "./Quotation-Table.vue?vue&type=script&lang=js"
export * from "./Quotation-Table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b2c3468",
  null
  
)

export default component.exports